import {
  ajaxUniGet,
  ajaxUniPostUsingCaptcha,
  ajaxUniPut,
  ajaxUniDelete,
  ajaxLogout,
  ajaxPlatebniBranaPost,
  checkOkStatusInSuccessFunc,
} from './ajaxutils';
import {
  alertCtk,
  alertCtkOKFunction,
  confirmCtkButtons,
  alertCtkApiError,
  fillCountries,
} from './utils';
import {
  getValue,
  bindValidateHandlers,
  validateProfilePart,
  setErrorMessage,
  clearErrorMessage,
} from './validate';
import { logoutUser } from './login';

const jQuery = window.jQuery;

export function deleteUser(event) {
  event.preventDefault();
  confirmCtkButtons(
    'Pokud smažete svůj účet, nebudete mít již přístup ke svému profilu.<br>Opravdu chcete účet smazat?',
    'Smazat',
    'Ne',
    () => {
      deleteUserConfirmed();
    },
    () => {},
  );
  return false;
}

const successFunc = (result, textStatus, jqXHR) => {
  if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
    return false;
  }
  console.log('delete user returned');
  const parsed = JSON.parse(result.trim());
  console.log(parsed);
  const data = { ...parsed };
  if (data.status === 'ok') {
    alertCtkOKFunction('Uživatel byl smazán.', logoutUser);
  } else if (data.status === 'warning') {
    // alertCtk(        'Jelikož jsou Vaše služby stále aktivní, budete moci účet smazat až po jejich ukončení. Pokud máte stále zájem účet smazat, kontaktujte nás na e-mailu shop@ctk.cz',      );
    confirmCtkButtons(
      data.message + '<br>Trváte na smazání účtu?',
      'Opravdu smazat',
      'Ne',
      deleteUserConfirmedForced,
      () => {},
    );
  } else if (data.status === 'error') {
    // 'Jelikož jsou Vaše služby stále aktivní, budete moci účet smazat až po jejich ukončení. Pokud máte stále zájem účet smazat, kontaktujte nás na e-mailu shop@ctk.cz',
    alertCtk(data.message);
  }
};

export function deleteUserConfirmed() {
  const data = {};
  data.force = 'no';

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);
  ajaxUniDelete('DeleteUser', data, successFunc);
  return false;
}

export function deleteUserConfirmedForced() {
  const data = {};
  data.force = 'yes';

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  ajaxUniDelete('DeleteUser', data, successFunc);
  return false;
}
